import React from "react";

import { WindowFormat } from "./types";

export type BreakpointsContextValue = WindowFormat | undefined;

export const BreakpointsContext =
  React.createContext<BreakpointsContextValue>(undefined);
